import { useState, useRef, forwardRef } from "react"
import BlockHeader from "@/common/partials/block-header/block-header"
import Block from "@/components/wrappers/block"
import SwiperCore, { Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css/bundle"
import Image from "next/legacy/image"
import styles from "./quote-slider.module.css"
import Icon from "@/common/icons/arrow"
import QuoteIcon from "@/common/icons/quote"
import classNames from "classnames"

export default function QuoteSlider({ block }) {
  const { heading, items } = block.attrs

  const total = items.length
  const prevRef = useRef(null)
  const nextRef = useRef(null)
  const [slider, setSlider] = useState({
    current: 1,
    isFirst: true,
    isLast: false
  })

  SwiperCore.use([Navigation])

  const settings = {
    className: "relative",
    slidesPerView: "auto",
    observer: "true",
    watchSlidesProgress: true,
    watchslidesvisibility: "true",
    navigation: {
      nextEl: nextRef.current,
      prevEl: prevRef.current
    },
    onInit: (swiper) => {
      swiper.navigation.update()
    },
    onSlideChange: (swiper) => {
      setSlider({
        current: swiper.activeIndex + 1,
        isFirst: swiper.isBeginning,
        isLast: swiper.isEnd
      })
    }
  }

  if (total === 0) {
    return null
  }

  return (
    <Block block={block} className={styles.block}>
      {heading && <BlockHeader align="center" heading={heading} />}
      <Swiper {...settings}>
        {items.map((item, i) => {
          const key = "slide" + i
          return (
            <SwiperSlide key={key} className="slide">
              {item.media && item.media.url && (
                <div className="image">
                  <figure className="relative w-full">
                    <Image
                      src={item.media.url}
                      alt={item.media.alt}
                      width={item.media.width}
                      height={item.media.height}
                      sizes={item.media.sizes}
                    />
                  </figure>
                </div>
              )}
              <div className="text">
                <blockquote>
                  <QuoteIcon className="w-6 h-6 mx-auto mb-4 md:mx-0" />
                  <p>{item.quote}</p>
                  <span>{item.reference}</span>
                  <span>{item.referenceRole}</span>
                </blockquote>
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>
      {total > 1 && (
        <div className="navigation">
          <Arrow
            ref={prevRef}
            current={slider.current}
            total={total}
            direction="prev"
          />
          <span className="count">{`${slider.current}/${total}`}</span>
          <Arrow
            ref={nextRef}
            current={slider.current}
            total={total}
            direction="next"
          />
        </div>
      )}
    </Block>
  )
}

const Arrow = forwardRef((props, ref) => {
  const { direction } = props
  return (
    <button
      aria-label={direction === "next" ? "Nästa" : "Föregående"}
      ref={ref}
      className={classNames(styles.arrow, direction)}>
      <div className="circle">
        <Icon className="w-4 pointer-events-none" />
      </div>
    </button>
  )
})

Arrow.displayName = "Arrow"
